import { twMerge } from "tailwind-merge";
import { clsx, ClassValue } from "clsx";

/**
 * Combines class names using clsx and tailwind-merge
 * @param inputs - Class names to merge
 * @returns Merged class names with Tailwind conflict resolution
 */
export function cn(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}
